export default __webpack_public_path__ + "static/media/bankly.4bce3754.webp";